import { __decorate, __metadata } from "tslib";
import { EditorDefinition, ModelId, Model, Default, IsString } from '@core/shared/model';
import { Expose, Structure } from 'class-transformer-global-storage';
import { ValidateNested } from 'class-validator';
export const vttCueNodeObjectNames = {
  "v": 'Stimme/Sprecher',
  "lang": 'Sprache',
  "c": 'Klasse css?',
  "i": 'Kursiv',
  "b": 'Fett',
  "u": 'Unterstrichen',
  "ruby": ''
};
let VttTextNodeModel = /*#__PURE__*/(() => {
  let VttTextNodeModel = class VttTextNodeModel extends Model {};
  __decorate([Expose(), Default('text'), __metadata("design:type", String)], VttTextNodeModel.prototype, "type", void 0);
  __decorate([Expose(), IsString(), __metadata("design:type", String)], VttTextNodeModel.prototype, "value", void 0);
  VttTextNodeModel = __decorate([EditorDefinition('admin', ['type', 'value']), ModelId("VttTextNodeModel") // auto-generated by generate-model-ids
  ], VttTextNodeModel);
  return VttTextNodeModel;
})();
export { VttTextNodeModel };
let VttCueTreeModel = /*#__PURE__*/(() => {
  let VttCueTreeModel = class VttCueTreeModel extends Model {};
  __decorate([Expose(), Structure(Array, () => VttTextNodeModel), ValidateNested(), Default([{}]), __metadata("design:type", Array)], VttCueTreeModel.prototype, "children", void 0);
  VttCueTreeModel = __decorate([EditorDefinition('admin', {
    children: {
      loadDefinition: 'admin'
    }
  }), ModelId("VttCueTreeModel") // auto-generated by generate-model-ids
  ], VttCueTreeModel);
  return VttCueTreeModel;
})();
export { VttCueTreeModel };